import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground } from 'docz';
import { PlayState, Tween } from './../../../react-gsap/src/';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-playstate-and-totalprogress-props"
    }}>{`Use playState and totalProgress props`}</h1>
    <p>{`With the playState and progress/totalProgress props you can control a Tween or a Timeline.
So you don't need low-level access to play/reverse/pause/stop or seek to a position.`}</p>
    <p>{`From version 3.2.0 on the `}<inlineCode parentName="p">{`playState`}</inlineCode>{` prop also works for the initial state and the following states were added:
`}<inlineCode parentName="p">{`restartReverse`}</inlineCode>{`, `}<inlineCode parentName="p">{`stopEnd`}</inlineCode>{`, `}<inlineCode parentName="p">{`resume`}</inlineCode>{`.`}</p>
    <p>{`The following gsap functions are called internally, if the `}<inlineCode parentName="p">{`playState`}</inlineCode>{` prop change:`}</p>
    <pre><code parentName="pre" {...{}}>{`if (playState === PlayState.play) {
  gsap.play();
} else if (playState === PlayState.restart) {
  gsap.restart(true);
} else if (playState === PlayState.reverse) {
  gsap.reverse();
} else if (playState === PlayState.restartReverse) {
  gsap.reverse(0);
} else if (playState === PlayState.stop) {
  gsap.pause(0);
} else if (playState === PlayState.stopEnd) {
  gsap.reverse(0);
  gsap.pause();
} else if (playState === PlayState.pause) {
  gsap.pause();
} else if (playState === PlayState.resume) {
  gsap.resume();
}
`}</code></pre>
    <Playground __position={0} __code={'() => {\n  const [playState, setPlayState] = React.useState(PlayState.pause)\n  const [totalProgress, setTotalProgress] = React.useState(0)\n  return (\n    <Fragment>\n      <Tween\n        to={{ x: \'300px\' }}\n        duration={2}\n        playState={playState}\n        totalProgress={totalProgress}\n      >\n        <div\n          style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }}\n        />\n      </Tween>\n      <button onClick={() => setPlayState(PlayState.play)}>play</button>\n      <button onClick={() => setPlayState(PlayState.restart)}>restart</button>\n      <button onClick={() => setPlayState(PlayState.reverse)}>reverse</button>\n      <button onClick={() => setPlayState(PlayState.restartReverse)}>\n        restartReverse\n      </button>\n      <button onClick={() => setPlayState(PlayState.stop)}>stop</button>\n      <button onClick={() => setPlayState(PlayState.stopEnd)}>stopEnd</button>\n      <button onClick={() => setPlayState(PlayState.pause)}>pause</button>\n      <button onClick={() => setPlayState(PlayState.resume)}>resume</button>\n      <div>\n        <input\n          type=\"range\"\n          max=\"1\"\n          step=\"0.001\"\n          value={totalProgress}\n          onChange={event => setTotalProgress(event.target.value)}\n        />\n      </div>\n    </Fragment>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      PlayState,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [playState, setPlayState] = React.useState(PlayState.pause);
        const [totalProgress, setTotalProgress] = React.useState(0);
        return <Fragment mdxType="Fragment">
        <Tween to={{
            x: '300px'
          }} duration={2} playState={playState} totalProgress={totalProgress} mdxType="Tween">
          <div style={{
              width: '100px',
              height: '100px',
              background: '#ccc'
            }} />
        </Tween>
        <button onClick={() => setPlayState(PlayState.play)}>play</button>
        <button onClick={() => setPlayState(PlayState.restart)}>restart</button>
        <button onClick={() => setPlayState(PlayState.reverse)}>reverse</button>
        <button onClick={() => setPlayState(PlayState.restartReverse)}>restartReverse</button>
        <button onClick={() => setPlayState(PlayState.stop)}>stop</button>
        <button onClick={() => setPlayState(PlayState.stopEnd)}>stopEnd</button>
        <button onClick={() => setPlayState(PlayState.pause)}>pause</button>
        <button onClick={() => setPlayState(PlayState.resume)}>resume</button>
        <div>
          <input type="range" max="1" step="0.001" value={totalProgress} onChange={event => setTotalProgress(event.target.value)} />
        </div>
      </Fragment>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      